import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Mixpanel } from 'helpers/Mixpanel';
import './ScheduleSearchFilterComponent.scss';

class SelectSkillPopover extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isShowingSkillList: false,
      selectedSkill: null,
    };
  }

  toggleSkillList = () => {
    this.setState(prev => ({ isShowingSkillList: !prev.isShowingSkillList }));
  };

  skillSelected = (skill) => {
    this.setState({ selectedSkill: skill, isShowingSkillList: false });
  };

  handleDoneClick = () => {
    const { handleSkillSelect } = this.props;
    const { selectedSkill } = this.state;
    handleSkillSelect(selectedSkill);
    Mixpanel.track('Confirm Skill To Filter');
  };

  handleClearAllClick = () => {
    this.setState({ selectedSkill: null, isShowingSkillList: false });
    Mixpanel.track('Tap Skill Clear All');
  };

  render() {
    const { skills, dropdownPos } = this.props;
    const { isShowingSkillList, selectedSkill } = this.state;

    const isText = (<FormattedMessage id="SearchFilter.is" defaultMessage="is" />);
    const clearAllText = (<FormattedMessage id="SearchFilter.clearAll" defaultMessage="Clear all" />);
    const doneText = (<FormattedMessage id="SearchFilter.done" defaultMessage="Done" />);

    const skillList = skills.map(skill => (
      <li key={skill.id} onClick={() => this.skillSelected(skill)}>
        <span>{skill.skill_content}</span>
      </li>
    ));

    return (
      <div className="select-department-popover" style={{ position: 'absolute', top: dropdownPos.top, left: dropdownPos.left }}>
        <div className="flex-row top-row">
          <label>{isText}</label>
          <button className="clear-all-btn" onClick={this.handleClearAllClick}>{clearAllText}</button>
        </div>

        <button className={isShowingSkillList ? 'department-button arrow-up' : 'department-button arrow-down'} onClick={this.toggleSkillList}>
          {selectedSkill?.skill_content || ''}
        </button>

        <div className={isShowingSkillList ? 'department-dropdown shown' : 'department-dropdown not-shown'}>
          <ul>{skillList}</ul>
        </div>

        <button className="done-button" onClick={this.handleDoneClick}>{doneText}</button>
      </div>
    );
  }
}

export default injectIntl(SelectSkillPopover);
